const defaultMeta = {
};

export default {
  path: '/tools',
  name: 'tools',
  redirect: {
    name: 'effort-estimator-tool',
  },
  component: () => import(/* webpackChunkName: "tools" */ '../views/ToolsListPage.vue'),
  meta: {
    ...defaultMeta,
  },
  children: [
    {
      path: 'effort-estimator',
      name: 'effort-estimator-tool',
      component: () => import(/* webpackChunkName: "estimator" */ '../views/EstimatorToolPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: 'tax-calculator',
      name: 'tax-calculator-tool',
      component: () => import(/* webpackChunkName: "tax-calculator" */ '../views/TaxCalculatorPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: 'salary-estimator',
      name: 'salary-estimator-tool',
      component: () => import(/* webpackChunkName: "salary-estimator" */ '../views/SalaryEstimatorPage.vue'),
      meta: {
        ...defaultMeta,
        roles: ['admin'],
      },
    },
    {
      path: 'budget-planner',
      name: 'budget-planner-tool',
      component: () => import(/* webpackChunkName: "budget-planner" */ '../views/BudgetPlannerPage.vue'),
      meta: {
        ...defaultMeta,
      },
    },
    {
      path: '*',
      redirect: {
        name: 'effort-estimator-tool',
      },
    },
  ],
};
